export interface ICommand { }

export class CreatePnlCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Pnls.Commands.CreatePnlCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	StartYear: number | null
	StartMonth: number | null
	Columns: string

	constructor (workspaceId: number, strategyId: string, id: string, name: string, startYear: number | null, startMonth: number | null, columns: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.StartYear = startYear
		this.StartMonth = startMonth
		this.Columns = columns
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Pnls.Commands.CreatePnlCommandV1, TCh.Domain.Quest'
	}

}

export class DeletePnlCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Pnls.Commands.DeletePnlCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string

	constructor (workspaceId: number, strategyId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Pnls.Commands.DeletePnlCommandV1, TCh.Domain.Quest'
	}

}

export class UpdatePnlCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Pnls.Commands.UpdatePnlCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	StartYear: number | null
	StartMonth: number | null
	Columns: string

	constructor (workspaceId: number, strategyId: string, id: string, name: string, startYear: number | null, startMonth: number | null, columns: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.StartYear = startYear
		this.StartMonth = startMonth
		this.Columns = columns
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Pnls.Commands.UpdatePnlCommandV1, TCh.Domain.Quest'
	}

}

